import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
  Validators,
} from '@angular/forms';
import { SdvorIconComponent } from '../icon';

@Component({
  selector: 'sd-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  imports: [CommonModule, SdvorIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(mouseleave)': 'resetValue()',
    '[attr.disabled]': 'disabled',
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: StarRatingComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: StarRatingComponent,
    },
  ],
})
export class StarRatingComponent implements ControlValueAccessor, Validator {
  iconClass = input<string>('');

  protected displayedValue = computed(() => this.unsavedValue() || this.value());
  protected disabled = false;
  private touched = false;
  private value = signal<number>(0);
  private unsavedValue = signal<number>(0);

  resetValue(): void {
    if (this.disabled) {
      return;
    }

    this.unsavedValue.set(0);
  }

  setValue(rating: number): void {
    if (this.disabled) {
      return;
    }

    this.unsavedValue.set(rating);
  }

  saveValue(rating: number): void {
    this.markAsTouched();

    if (this.disabled) {
      return;
    }

    this.value.set(rating);
    this.onChange(rating);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  onChange = (_rate: number): void => {};

  onTouched = (): void => {};

  writeValue(rate: number): void {
    this.value.set(rate);
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const rate = control.value;

    if (control.hasValidator(Validators.required) && (rate === null || rate <= 0)) {
      return { required: true };
    }

    return null;
  }
}
